import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  xmlns: "http://www.w3.org/2000/svg",
  viewBox: "0 0 14.53 18"
}

function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, _cache[0] || (_cache[0] = [
    _createElementVNode("path", {
      fill: "currentColor",
      d: "M10.17 15.7H2.16l.05-5.36L1 10.33.99 17h10.45v-6.64h-1.27z"
    }, null, -1),
    _createElementVNode("path", {
      fill: "currentColor",
      d: "M2.96 13.49h6.28v1.34H2.96zm.018-1.034.132-1.364 6.281.606-.132 1.364zm.338-2.762.372-1.318 6.073 1.714-.372 1.318zm1.138-3.217.708-1.173 5.402 3.262-.709 1.173zm2.664-3.29 1.113-.798 3.676 5.128-1.114.798zm4.032-1.961L12.5 1l1.04 6.224-1.35.226z"
    }, null, -1)
  ])))
}
export default { render };